import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewRenterPageNew from "../../components/Renter/ViewRenterPageNew";



const ViewRenterPage=() => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Renter" title2="Renter" link2="/renter" />

        {/* AddUserLayer */}
        <ViewRenterPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewRenterPage;
